import React from "react";
import Default from "./Default";

const Settings = ({ match }) => {
    return (
        <Default />
    )
};

export default Settings;